var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("router-module"),
      _c("section", { staticClass: "pa pa--t_md pa--b_md" }, [
        _c("div", { staticClass: "ug-container ug-container--variant_large" }, [
          _c(
            "div",
            {
              staticClass:
                "ug-row ug-row--apearance_spaced ug-row--space_md ug-row--align_center"
            },
            [
              _c(
                "div",
                { staticClass: "ug-cell" },
                [
                  this.$route.params.from === "statistics"
                    ? _c(
                        "router-link",
                        {
                          staticClass: "button button--go-back",
                          attrs: { to: { name: "StatisticsCabinet" } }
                        },
                        [_c("div", { staticClass: "icon icon--type_prev" })]
                      )
                    : _vm._e(),
                  this.$route.params.from === "order"
                    ? _c(
                        "router-link",
                        {
                          staticClass: "button button--go-back",
                          attrs: { to: { name: "OrderHistoryCabinet" } }
                        },
                        [_c("div", { staticClass: "icon icon--type_prev" })]
                      )
                    : _vm._e(),
                  this.$route.params.from === "balance"
                    ? _c(
                        "router-link",
                        {
                          staticClass: "button button--go-back",
                          attrs: { to: { name: "BalanceHistoryCabinet" } }
                        },
                        [_c("div", { staticClass: "icon icon--type_prev" })]
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "ug-cell" },
                [
                  _c(
                    "text-bemto",
                    {
                      attrs: {
                        fw: "bold",
                        lh: "initial",
                        fs: "xl",
                        color: "black",
                        tag: "p"
                      }
                    },
                    [_vm._v("ORDER ID " + _vm._s(_vm.$route.params.id))]
                  )
                ],
                1
              )
            ]
          ),
          _c("div", { staticClass: "pa pa--f_md bg bg--white ma ma--t_md" }, [
            _c(
              "div",
              {
                staticClass: "ug-row ug-row--apearance_spaced ug-row--space_md"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "ug-cell ug-cols ug-cols--12 ug-cols--6-md ug-cols--4-lg ug-cols--3-xl"
                  },
                  [
                    _c("div", { staticClass: "control-cabinet" }, [
                      _c("div", { staticClass: "control-cabinet__label" }, [
                        _vm._v("Uuid:")
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "control-cabinet__element control-cabinet__element--centered"
                        },
                        [_vm._v(_vm._s(_vm.formData.uuid || "-"))]
                      )
                    ])
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "ug-cell ug-cols ug-cols--12 ug-cols--6-md ug-cols--4-lg ug-cols--3-xl"
                  },
                  [
                    _c("div", { staticClass: "control-cabinet" }, [
                      _c("div", { staticClass: "control-cabinet__label" }, [
                        _vm._v("Prepayment:")
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "control-cabinet__element control-cabinet__element--centered"
                        },
                        [_vm._v(_vm._s(_vm.formData.prepayment || "-"))]
                      )
                    ])
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "ug-cell ug-cols ug-cols--12 ug-cols--6-md ug-cols--4-lg ug-cols--3-xl"
                  },
                  [
                    _c("div", { staticClass: "control-cabinet" }, [
                      _c("div", { staticClass: "control-cabinet__label" }, [
                        _vm._v("Car registration:")
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "control-cabinet__element control-cabinet__element--centered"
                        },
                        [_vm._v(_vm._s(_vm.formData.carRegistration || "-"))]
                      )
                    ])
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "ug-cell ug-cols ug-cols--12 ug-cols--6-md ug-cols--4-lg ug-cols--3-xl"
                  },
                  [
                    _c("div", { staticClass: "control-cabinet" }, [
                      _c("div", { staticClass: "control-cabinet__label" }, [
                        _vm._v("Postal Code:")
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "control-cabinet__element control-cabinet__element--centered"
                        },
                        [_vm._v(_vm._s(_vm.formData.postCode || "-"))]
                      )
                    ])
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "ug-cell ug-cols ug-cols--12 ug-cols--8-lg ug-cols--6-xl ug-cols--3-mac"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "ug-row ug-row--apearance_spaced ug-row--space_md ug-row--align_end"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "ug-cell ug-cols ug-cols--12 ug-cols--6-sm ug-cols--6-xl ug-cols--6-mac ug-cols--7-fhd"
                          },
                          [
                            _c("div", { staticClass: "control-cabinet" }, [
                              _c(
                                "div",
                                { staticClass: "control-cabinet__label" },
                                [_vm._v("Date at:")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "control-cabinet__element control-cabinet__element--centered control-cabinet__element--date"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.formData.bookingDate || "-")
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "ug-cell ug-cols ug-cols--12 ug-cols--6-sm ug-cols--6-xl ug-cols--6-mac ug-cols--5-fhd"
                          },
                          [
                            _c("div", { staticClass: "control-cabinet" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "control-cabinet__element control-cabinet__element--centered control-cabinet__element--time"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.formData.bookingTime || "-")
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "ug-cell ug-cols ug-cols--12 ug-cols--6-md ug-cols--4-lg ug-cols--3-xl"
                  },
                  [
                    _c("div", { staticClass: "control-cabinet" }, [
                      _c("div", { staticClass: "control-cabinet__label" }, [
                        _vm._v("Responsible:")
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "control-cabinet__element control-cabinet__element--centered"
                        },
                        [_vm._v(_vm._s(_vm.formData.responsibleName || "-"))]
                      )
                    ])
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "ug-cell ug-cols ug-cols--12 ug-cols--6-md ug-cols--4-lg ug-cols--3-xl"
                  },
                  [
                    _c("div", { staticClass: "control-cabinet" }, [
                      _c("div", { staticClass: "control-cabinet__label" }, [
                        _vm._v("Phone:")
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "control-cabinet__element control-cabinet__element--centered"
                        },
                        [_vm._v(_vm._s(_vm.formData.phone || "-"))]
                      )
                    ])
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "ug-cell ug-cols ug-cols--12 ug-cols--6-md ug-cols--4-lg ug-cols--3-xl"
                  },
                  [
                    _c("div", { staticClass: "control-cabinet" }, [
                      _c("div", { staticClass: "control-cabinet__label" }, [
                        _vm._v("Service:")
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "control-cabinet__element control-cabinet__element--centered"
                        },
                        [_vm._v(_vm._s(_vm.formData.serviceName || "-"))]
                      )
                    ])
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "ug-cell ug-cols ug-cols--12 ug-cols--6-md ug-cols--4-lg ug-cols--3-xl"
                  },
                  [
                    _c("div", { staticClass: "control-cabinet" }, [
                      _c("div", { staticClass: "control-cabinet__label" }, [
                        _vm._v("Price:")
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "control-cabinet__element control-cabinet__element--centered"
                        },
                        [_vm._v(_vm._s(_vm.formData.price || "-"))]
                      )
                    ])
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "ug-cell ug-cols ug-cols--12 ug-cols--6-md ug-cols--4-lg ug-cols--3-xl"
                  },
                  [
                    _c("div", { staticClass: "control-cabinet" }, [
                      _c("div", { staticClass: "control-cabinet__label" }, [
                        _vm._v("Full name:")
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "control-cabinet__element control-cabinet__element--centered"
                        },
                        [_vm._v(_vm._s(_vm.formData.name || "-"))]
                      )
                    ])
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "ug-cell ug-cols ug-cols--12 ug-cols--6-md ug-cols--4-lg ug-cols--3-xl"
                  },
                  [
                    _c("div", { staticClass: "control-cabinet" }, [
                      _c("div", { staticClass: "control-cabinet__label" }, [
                        _vm._v("House Number And Street")
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "control-cabinet__element control-cabinet__element--centered"
                        },
                        [_vm._v(_vm._s(_vm.formData.address || "-"))]
                      )
                    ])
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "ug-cell ug-cols ug-cols--12 ug-cols--6-md ug-cols--4-lg ug-cols--3-xl"
                  },
                  [
                    _c("div", { staticClass: "control-cabinet" }, [
                      _c("div", { staticClass: "control-cabinet__label" }, [
                        _vm._v("Is paid:")
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "control-cabinet__element control-cabinet__element--centered"
                        },
                        [_vm._v(_vm._s(_vm.formData.isPaid))]
                      )
                    ])
                  ]
                )
              ]
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d1ae8058", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1ae8058","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/Pages/Cabinet/BalanceDetailsCabinet.vue
// module id = 849
// module chunks = 0